import 'slick-carousel'

export default (() => {
    const matchHeight = () => {
      if (window.matchMedia('(max-width: 991px)').matches) {

        const highest = Math.max.apply(null, $(".header-hero-content").map(function (){
            return $(this).outerHeight();
        }).get());

        $('.header-hero-content').css({'min-height': `${highest}px`});
      } else {
        $('.header-hero-content').css({'min-height': `none`});
      }
    }

    $('.header-slider').on('init, setPosition', function() {
      matchHeight();
    });

    $('.header-slider').slick({
      dots: true,
      prevArrow: $('.header-slider-previous'),
      nextArrow: $('.header-slider-next')
    });

    // Handle multi agreement checkboxes
    const checkAgreementCheckboxes = ($checkBox) => {
      let $form = $checkBox.closest('.cta-form');
      let isValid = true;

      $form.find('[data-agreement-multi]').each(function() {
        if(!$(this).is(":checked")) {
          isValid = false;
          return;
        }
      });

      if(isValid) {
        $form.find('.field-submit .btn').each(function() {
          $(this).attr('href', $(this).attr('data-href'));
          $(this).removeAttr('disabled').removeClass('disabled')
        });
      } else {
        $form.find('.field-submit .btn').attr('disabled', true).addClass('disabled').removeAttr('href');
      }
    }

    $('[data-agreement-multi]').on('change', function() {
      checkAgreementCheckboxes($(this));
    });

    $('[data-agreement-multi]').closest('.cta-form').each(function() {
      checkAgreementCheckboxes($(this));
    });


})()
